import moment from 'moment-timezone';

export const notEmpty = <T>(value: T): value is NonNullable<typeof value> => !!value;

export const isArray =
  (Array.isArray as <T>(x: any) => x is T[]) || (<T>(x: any): x is T[] => x && typeof x.length === 'number');

export const isValidEmail = (email: string) => email.match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);

/** Relative "time ago" string matching StatusCard's timeAgo (moment.fromNow tweaked). */
export const formatTimeAgo = (dateIso: string | Date): string => {
  const diff = moment().diff(moment(dateIso), 'minutes');
  if (diff > 6.5 * 24 * 60) return '7+ days ago';
  if (diff < 10) return 'now';
  return moment(dateIso).locale('en').fromNow().replace('minutes', 'min');
};
